import { APP_ENV } from '@my/config'
//import { useAuth } from '@clerk/react'
import {
  Separator,
  Spinner,
  YStack,
  XStack,
  Group,
  H2,
  Card,
  Button,
} from '@my/ui'
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthedRequestFn, useAuth, useNavigate } from '@my/util';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { defaultTo } from 'lodash';

const pricingTablesMap = {
  web: {
    production: 'prctbl_1TPEbY46wiwK6xgqkef683Kr',
    staging: 'prctbl_1SHwBvQLFB9E15sAgoEyjGEd',
    development: 'prctbl_1SIQCEQLFB9E15sAe0xjtcsz'
  },
  native: {
    production: 'prctbl_1TTF8U46wiwK6xgqRfEQzWiy',
    //staging: 'prctbl_1SHwBvQLFB9E15sAgoEyjGEd',
    development: 'prctbl_1TTEuLQLFB9E15sA1zS5BTAp'
  }
};

const pricingTables = Platform.select(pricingTablesMap)

const PRICING_TABLE_ID = (() => defaultTo(pricingTables?.[APP_ENV.TZA_ENV], pricingTables?.development))();

export const PricingPage: React.FC<{ 
  onCancel: (...x) => any; 
  pricingTableId?: string;
  chosenPlan: "" | 'growth' | 'premium' | 'institutional';
}> = (props) => {
  const { userId } = useAuth()
  //const queryClient = useQueryClient()
  const authedRequestFn = useAuthedRequestFn()
  const formDataQuery = useQuery({
    queryKey: ['user-profile'],
    queryFn: () => authedRequestFn('/user-profile'),
  }) 
  const [customerSessionClientSecret, setCustomerSessionClientSecret] = useState('');

  useEffect(() => {
    if (formDataQuery.data?.metadata?.['stripeCustomerId']) {
      const proFn = async () => {
        const queryParams = new URLSearchParams({
          product: props.chosenPlan,
          env: APP_ENV.TZA_ENV_CONTEXT
        });
        const urlPath = '/user-profile/billing-checkout?'+queryParams.toString();
        const {checkoutUrl} = await authedRequestFn(urlPath);
        if (checkoutUrl) {
          window.location = checkoutUrl;
        }
      }
      proFn();
    }
  }, [formDataQuery.data])

  /* useEffect(() => {
    if (formDataQuery.data?.metadata?.['stripeCustomerId'] && !customerSessionClientSecret) {
      const proFn = async () => {
        const result = await authedRequestFn('/user-profile/billing-session');
        if (result.clientSecret) {
          setCustomerSessionClientSecret(result.clientSecret);
        }
      }
      proFn();
    }
  }, [formDataQuery.data]) */

  const pricingTableId = defaultTo(props.pricingTableId, PRICING_TABLE_ID);
  // Paste the stripe-pricing-table snippet in your React component
  return (
    <Card style={{
      maxWidth: 1000, 
      width: '100%',
      borderWidth: 1, borderStyle: 'solid',
      borderColor: 'rgb(230,230,230)'
    }}>
      <Card.Header>
        <H2>Account Registration</H2>
      </Card.Header>
      <YStack gap={10} style={{padding: '0 18px 18px'}}>
        {customerSessionClientSecret ? <>
          <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
          <stripe-pricing-table
            style={{width: '100%', paddingTop: '10px', backgroundColor: 'white'}}
            pricing-table-id={pricingTableId}
            publishable-key={APP_ENV.STRIPE_PUBLISHABLE_KEY}
            client-reference-id={userId}
            customer-session-client-secret={customerSessionClientSecret}
          /> 
        </> : undefined}
      </YStack>
      <Card.Footer>
        <XStack style={{alignItems: 'center', width: '100%', padding: 18}} gap={5}>
      
          <Group size="$3" orientation="horizontal" gap={5} marginLeft='auto' marginTop={10} borderRadius={9}>
            <Group.Item>
              <Button 
                {...({color: '#ff3333'})}
                onPress={props.onCancel} size="$3"
              >Cancel</Button>
            </Group.Item>
        </Group>
        </XStack>
      </Card.Footer>
    </Card>
  );
}

export const MobilePricingPage: React.FC<{}> = () => {
  const exitUri = 'https://useparity.app/universal-link-callback?error-exit'
  const pricingTableId = pricingTablesMap.native[APP_ENV.TZA_ENV as keyof typeof pricingTablesMap.native]
  const onCancel= () => { window.location.href = exitUri; }
  return <YStack 
    f={1} 
    bc="$background" 
    p="$4" 
    gap={20} /* $platform-web={{ padding: sm ? 0 : '$4' }} */ 
    bg="#fff"
    style={{
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    <PricingPage {...{pricingTableId, onCancel}} />
  </YStack>
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}